/**
 * Utility functions for property type handling
 */

export const getPropertyTypeLabel = (type: string): string => {
  const key = (type || '').toLowerCase();
  const typeMap: { [key: string]: string } = {
    'apartment': 'Căn hộ',
    'house': 'Nhà riêng',
    'villa': 'Biệt thự',
    'condo': 'Căn hộ',
    'townhouse': 'Townhouse',
    'penthouse': 'Penthouse',
    'duplex': 'Duplex',
    'studio': 'Studio',
    'warehouse': 'Kho bãi',
    'office': 'Văn phòng',
    'land': 'Đất nền',
    'commercial': 'Thương mại',
    'farmhouse': 'Farmhouse',
    'factory': 'Nhà xưởng',
    'shop': 'Cửa hàng',
    'store': 'Cửa hàng',
    'restaurant': 'Nhà hàng',
    'hotel': 'Khách sạn',
    'hostel': 'Nhà trọ',
    'motel': 'Nhà trọ',
    'popup': 'Popup',
    'sleepbox': 'Sleepbox',
    'cabin': 'Cabin',
    // Legacy DB / Meilisearch (underscore Vietnamese)
    'căn_hộ': 'Căn hộ',
    'căn hộ': 'Căn hộ',
    'nhà_riêng': 'Nhà riêng',
    'nhà riêng': 'Nhà riêng',
    'biệt_thự': 'Biệt thự',
    'biệt thự': 'Biệt thự',
    'văn_phòng': 'Văn phòng',
    'văn phòng': 'Văn phòng',
    'cửa_hàng': 'Cửa hàng',
    'cửa hàng': 'Cửa hàng',
    'kho_bãi': 'Kho bãi',
    'đất_nền': 'Đất nền',
    'đất nền': 'Đất nền',
    'nhà_trọ': 'Nhà trọ',
    'nhà trọ': 'Nhà trọ'
  };
  return typeMap[key] || type;
};

export const getPropertyTypeIcon = (type: string): string => {
  const iconMap: { [key: string]: string } = {
    'apartment': 'fas fa-building',
    'house': 'fas fa-home',
    'villa': 'fas fa-house',
    'condo': 'fas fa-building',
    'townhouse': 'fas fa-home',
    'penthouse': 'fas fa-building',
    'duplex': 'fas fa-home',
    'studio': 'fas fa-home',
    'warehouse': 'fas fa-warehouse',
    'office': 'fas fa-briefcase',
    'land': 'fas fa-map',
    'commercial': 'fas fa-store',
    'farmhouse': 'fas fa-home',
    'factory': 'fas fa-industry',
    'shop': 'fas fa-store',
    'store': 'fas fa-store',
    'restaurant': 'fas fa-utensils',
    'hotel': 'fas fa-bed',
    'hostel': 'fas fa-bed',
    'motel': 'fas fa-bed',
    'popup': 'fas fa-store-alt',
    'sleepbox': 'fas fa-cube',
    'cabin': 'fas fa-home',
    'căn_hộ': 'fas fa-building',
    'căn hộ': 'fas fa-building',
    'nhà_riêng': 'fas fa-home',
    'nhà riêng': 'fas fa-home',
    'biệt_thự': 'fas fa-house',
    'biệt thự': 'fas fa-house',
    'văn_phòng': 'fas fa-briefcase',
    'văn phòng': 'fas fa-briefcase',
    'cửa_hàng': 'fas fa-store',
    'cửa hàng': 'fas fa-store',
    'kho_bãi': 'fas fa-warehouse',
    'đất_nền': 'fas fa-map',
    'đất nền': 'fas fa-map',
    'nhà_trọ': 'fas fa-bed',
    'nhà trọ': 'fas fa-bed'
  };
  return iconMap[type.toLowerCase()] || 'fas fa-home';
};

export const getPropertyTypeColor = (type: string): string => {
  const colorMap: { [key: string]: string } = {
    'apartment': '#C4A35A',
    'house': '#2563eb',
    'villa': '#dc2626',
    'condo': '#C4A35A',
    'townhouse': '#2563eb',
    'penthouse': '#7c3aed',
    'duplex': '#2563eb',
    'studio': '#C4A35A',
    'warehouse': '#ea580c',
    'office': '#0891b2',
    'land': '#16a34a',
    'commercial': '#ca8a04',
    'farmhouse': '#16a34a',
    'factory': '#ea580c',
    'shop': '#ca8a04',
    'store': '#ca8a04',
    'restaurant': '#dc2626',
    'hotel': '#7c3aed',
    'hostel': '#7c3aed',
    'motel': '#7c3aed',
    'popup': '#ca8a04',
    'sleepbox': '#7c3aed',
    'cabin': '#16a34a',
    'căn_hộ': '#C4A35A',
    'căn hộ': '#C4A35A',
    'nhà_riêng': '#2563eb',
    'nhà riêng': '#2563eb',
    'biệt_thự': '#dc2626',
    'biệt thự': '#dc2626',
    'văn_phòng': '#0891b2',
    'văn phòng': '#0891b2',
    'cửa_hàng': '#ca8a04',
    'cửa hàng': '#ca8a04',
    'kho_bãi': '#ea580c',
    'đất_nền': '#16a34a',
    'đất nền': '#16a34a',
    'nhà_trọ': '#7c3aed',
    'nhà trọ': '#7c3aed'
  };
  return colorMap[type.toLowerCase()] || '#C4A35A';
};
